import React from "react";
import { arrayOf, bool, shape, number } from "prop-types";
import Grid from "react-bootstrap/lib/Grid";
import Row from "react-bootstrap/lib/Row";
import Col from "react-bootstrap/lib/Col";
import { connect, useDispatch } from "react-redux";
import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";
import Loader from "pages/_components/Loader";
import NoMoreData from "pages/_components/NoMoreData";
import StatementItem from "./StatementItem";
import useStatements from "./useStatements";

const StatementList = (props) => {
    const { fetching, filters, statements, accountId } = props;

    const newFilter = { ...filters, accountId };
    useStatements(newFilter);
    const dispatch = useDispatch();
    const filteredStatements = statements?.itemList;

    const handleDownload = (id) => {
        dispatch(accountsActions.downloadStatement(id));
    };

    if (fetching) {
        return <Loader />;
    }

    return (
        <div className="above-the-fold">
            {filteredStatements?.length ? (
                <section className="container--layout flex-grow">
                    <Grid fluid>
                        <Row className="justify-content-center">
                            <Col xs={12}>
                                <ul className="navigational-list">
                                    {filteredStatements.map((statement) => (
                                        <li key={`statement-${statement.id}`} className="navigational-list-item">
                                            <StatementItem statement={statement} handleClick={handleDownload} />
                                        </li>
                                    ))}
                                </ul>
                            </Col>
                        </Row>
                    </Grid>
                </section>
            ) : (
                <NoMoreData />
            )}
        </div>
    );
};

const mapStateToProps = (state) => ({
    fetching: accountsSelectors.getFetchingMovements(state),
    statements: accountsSelectors.getStatements(state),
    filters: accountsSelectors.getFilters(state),
});

StatementList.propTypes = {
    fetching: bool.isRequired,
    statements: arrayOf(shape({})).isRequired,
    filters: shape({}).isRequired,
    accountId: number.isRequired,
};

export default connect(mapStateToProps)(StatementList);
